// subscription-manager.js
(function() {
  'use strict';

  if (!window.subscriptionEventListenersAdded) {
    window.subscriptionEventListenersAdded = true;

    /** ✅ Handle checkbox clicks (Buy Once / Subscribe) **/
    document.addEventListener('click', function(event) {
      const wrapper = event.target.closest('.subscription__checkbox-wrapper');
      if (!wrapper) return;

      const checkbox = wrapper.querySelector('.subscription__checkbox');
      if (!checkbox) return;

      const type = checkbox.dataset.type; // "buy-once" or "subscribe"

      // Toggle clicked one manually
      checkbox.checked = !checkbox.checked;

      // If one is checked, uncheck the other group
      const oppositeType = type === 'buy-once' ? 'subscribe' : 'buy-once';
      const allCheckboxes = document.querySelectorAll('.subscription__checkbox[data-sync-group="subscription"]');

      allCheckboxes.forEach(cb => {
        if (cb !== checkbox && cb.dataset.type === oppositeType) {
          cb.checked = false;
        }
      });

      // Determine which mode is active
      const isSubscribe = checkbox.checked && type === 'subscribe';
      const isBuyOnce = checkbox.checked && type === 'buy-once';

      // Update dropdown visibility
      const wrappers = document.querySelectorAll('.subscription__select-wrapper');
      wrappers.forEach(w => {
        w.style.display = isSubscribe ? 'block' : 'none';
      });

      // Sync checkboxes across DOM
      document.querySelectorAll(`.subscription__checkbox[data-type="buy-once"]`).forEach(cb => {
        if (cb !== checkbox) cb.checked = isBuyOnce;
      });
      document.querySelectorAll(`.subscription__checkbox[data-type="subscribe"]`).forEach(cb => {
        if (cb !== checkbox) cb.checked = isSubscribe;
      });

      // Trigger change for all synced elements
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    });

    /** ✅ Handle dropdown syncing across all sections **/
    document.addEventListener('change', function(e) {
      if (e.target.classList.contains('subscription__select')) {
        const value = e.target.value;
        document.querySelectorAll('.subscription__select').forEach(select => {
          if (select !== e.target) select.value = value;
        });
      }
    });

    /** ✅ Initialize default state on load **/
    document.addEventListener('DOMContentLoaded', function() {
      const buyOnceCheckboxes = document.querySelectorAll('.subscription__checkbox[data-type="buy-once"]');
      const subscribeCheckboxes = document.querySelectorAll('.subscription__checkbox[data-type="subscribe"]');

      // Default: Buy Once checked, Subscribe unchecked
      buyOnceCheckboxes.forEach(cb => cb.checked = true);
      subscribeCheckboxes.forEach(cb => cb.checked = false);

      // Hide dropdown initially
      document.querySelectorAll('.subscription__select-wrapper').forEach(wrapper => {
        wrapper.style.display = 'none';
      });

      // Fire initial change to sync with add-to-cart buttons
      buyOnceCheckboxes.forEach(cb => {
        cb.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }
})();
